import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-text-field',
  templateUrl: './input-text-field.component.html',
  styleUrls: ['./input-text-field.component.scss']
})
export class InputTextFieldComponent implements OnInit {

  @Input() placeholder: string = '';
  @Input() control: FormControl = new FormControl;
  @Input() searchField: boolean = false;
  @Input() addButton: boolean = false;
  @Input() size: 'sml' | 'md' | 'big' = 'md'
  @Input() value: string = ''
  @Input() disabled = false;
  @Input() mask: string = '';

  @Output() clickButton = new EventEmitter;
  @Output() valueChanged = new EventEmitter<string>();

  ngOnInit(): void {
    this.updateControl()
    this.control.valueChanges.subscribe(x => {
      this.value = x
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.updateControl()
    }
    if (changes['disabled']) {
      if (this.disabled) {
        this.control.disable()
      } else {
        this.control.enable()
      }
    }
  }

  _change() {
    this.valueChanged.emit(this.control.value)
  }

  updateControl() {
    this.control.patchValue(this.value)
  }

  onAddClick() {
    this.clickButton.emit(this.control.value);
    this.value = ''
  }

  getMask() {

    return this.mask;
  }
}
